// extracted by mini-css-extract-plugin
module.exports = {"item":"Knowledge_item__26xp9"};